export default {
    languages: [{ value: "rs-RS", text: "Srpski" }, { value: "sr-SR", text: "Српски" }, { value: "hu-HU", text: "Magyar" }, { value: "hr-HR", text: "Hrvatski" }, { value: "en-EN", text: "English" }],
    language_books: [
        {
            value: "rs-RS",
            text: "serbian"
        },
        {
            value: "hu-HU", text: "hungarian"
        },
        {
            value: "en-EN", text: "english"
        },
        {
            value: "hr-HR", text: "croatian"
        },
        {
            value: "de-DE", text: "german"
        }]
}
